const SkipToContent = (function () {
  return {
    init: () => {
      const skipLink = document.querySelector('.js-a11y-skip-link');
      if (skipLink) {
        skipLink.addEventListener('click', () => {
          const mainEl = document.querySelector('#main');
          if (mainEl) {
            mainEl.setAttribute('tabindex', '-1');
            mainEl.focus({ preventScroll: true });
          }
        });
      }
    },
  };
})();

export default SkipToContent;
